/**
 * @returns {import("~/config/useGetRichtTextValues").RichTextValuesLocales}
 */
export const freiGijpRichtTextValues = {
  'de-DE': {
    contactEmail: 'stay@fresenius.com',
    homeUrl: '/',
    jobSearchUrl: '/job-suche',
    disclaimerUrl: '/datenschutz',
  },
  'en-US': {
    contactEmail: 'stay@fresenius.com',
    homeUrl: '/',
    jobSearchUrl: '/job-search',
    disclaimerUrl: '/datenschutz',
    privacyPolicyUrl: '/privacy-policy',
  },
  'es-ES': {
    contactEmail: 'stay@fresenius.com',
    homeUrl: '/',
    jobSearchUrl: '/buscar-empleo',
    disclaimerUrl: '/datenschutz',
    privacyPolicyUrl: '/privacy-policy',
  },
};
